
<template>
  <div class="error-content">
    <div class="error-content__title">
      {{ $t('Errors.CompanyAwaitingVerification') }}
    </div>
    <div
      class="ml-4 pt-4 pb-4 text-left h4-headline opacity-7">
      <div>{{ $t('Errors.CompanyAwaitingVerificationText_1') }}</div>
      <div>{{ $t('Errors.CompanyAwaitingVerificationText_2') }}</div>
      <div>{{ $t('Errors.CompanyAwaitingVerificationText_3') }}</div>
      <div>{{ $t('Errors.CompanyAwaitingVerificationText_4') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'verificationError',
  data() {
    return {
      route: {}
    }
  },
}
</script>
<style lang="scss" scoped>
.error-content {
  &__title {
    text-align: left;
    margin-left: 16px;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    @media (max-width:935px) {
      margin-left: 0;
      text-align: center;
    }
  }
}
</style>
